import { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import LanguageSelector from "../LanguageSelector/LanguageSelector";
import "./Topo.scss";
import Ho from "../../assets/img/ho.svg";
import Logo from "../../assets/img/essentia-group.svg";
import Menu from "../../assets/img/mobile/menu.svg";

const Topo = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const headerRef = useRef(null);
  const location = useLocation();

  // Verifica se está na página de qualidade para ocultar o seletor de idioma
  const isQualityPage = location.pathname === "/qualidade";

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Publica a altura real do header em --header-height para que as páginas
  // possam se posicionar abaixo do header fixo (desktop ~94px, mobile ~54px).
  useEffect(() => {
    const header = headerRef.current;
    if (!header) return;

    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty(
        "--header-height",
        `${header.offsetHeight}px`,
      );
    };

    updateHeaderHeight();

    const observer = new ResizeObserver(updateHeaderHeight);
    observer.observe(header);

    return () => observer.disconnect();
  }, []);

  const isMobile = window.innerWidth < 768;

  const handleSmoothScroll = (e, targetId) => {
    e.preventDefault();
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    closeMenu();
  };

  return (
    <header ref={headerRef}>
      <div className="superMenu">
        <div className="container">
          {" "}
          <a href="https://essentia.com.br/" target="_blank" rel="noreferrer">
            <span>Essentia Pharma</span>
          </a>
          <a
            href="https://www.essentialnutrition.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <span>Essential Nutrition</span>
          </a>
          <a
            href="https://www.noorskin.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <span>Noorskin</span>
          </a>
          <a
            href="https://essentiaexperience.com.br/"
            target="_blank"
            rel="noreferrer"
          >
            <span>Essentia Experience</span>
          </a>
          <a href="https://begenerous.com.br/" target="_blank" rel="noreferrer">
            <span>Be Generous</span>
          </a>
        </div>
      </div>
      <nav>
        {/* Renderiza o backdrop apenas em dispositivos móveis */}
        {isMobile && (
          <div
            className={`backdrop ${menuOpen ? "show" : ""}`}
            onClick={closeMenu}
          ></div>
        )}
        <div className="logo-links menu-logo-lang" ref={menuRef}>
          <button className="menu-icon" onClick={toggleMenu}>
            <img src={Menu} alt="Icone menu" />
          </button>
          <Link className="logo" to="/">
            <img src={Ho} alt="Logo Essential Nutrition" />
          </Link>
          {menuOpen && (
            <button className="close-icon" onClick={closeMenu}>
              X {/* Botão de fechar */}
            </button>
          )}
          <div className={`links ${menuOpen ? "show" : ""}`}>
            <ul>
              <li className="mobile">
                <img src={Logo} alt="Logo Essentia Group" />
              </li>
              <li>
                <Link to="/" onClick={closeMenu}>
                  Home
                </Link>
              </li>
              <li>
                <a href="/#nossas-marcas" onClick={closeMenu}>
                  Nossas marcas
                </a>
              </li>
              <li>
                <Link to="/essentiaexperience" onClick={closeMenu}>
                  Essentia Experience
                </Link>
              </li>
              <li>
                <Link to="/qualidade" onClick={closeMenu}>
                  Qualidade
                </Link>
              </li>
              <li className="none">
                <a rel="noreferrer" href="/conteudos">
                  Conteúdos
                </a>
              </li>
              <li>
                <Link to="/journal" onClick={closeMenu}>
                  Journal
                </Link>
              </li>
              <li>
                <Link to="/carreiras" onClick={closeMenu}>
                  Trabalhe conosco
                </Link>
              </li>
              <li>
                <Link to="/contatos" onClick={closeMenu}>
                  Contatos
                </Link>
              </li>
            </ul>
          </div>
          <div className="mobile lang">
            <LanguageSelector />
          </div>
          <div className="desktop">
            <LanguageSelector />
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Topo;
